import {
  useCreateConnectorMutation,
  useGetAllConnectorsQuery,
  useLazyGetConnectorDetailsQuery,
  useLazyGetExternalConnectorQuery,
} from "../../store/services/connectorQuery";

export const useConnector = () => {
  const [
    createConnector,
    {
      data: createConnectorData,
      isLoading: createConnectorIsLoading,
      isError: createConnectorIsError,
      error: createConnectorError,
      isSuccess: createConnectorIsSuccess,
    },
  ] = useCreateConnectorMutation();

  const {
    data: getAllConnectorsData,
    isLoading: getAllConnectorsIsLoading,
    isError: getAllConnectorsIsError,
    error: getAllConnectorsError,
    isSuccess: getAllConnectorsIsSuccess,
    refetch: refetchGetAllConnectors,
  } = useGetAllConnectorsQuery({});

  const [
    getConnectorDetails,
    {
      data: connectorData,
      isLoading: connectorIsLoading,
      isError: connectorIsError,
      error: connectorError,
      isSuccess: connectorIsSuccess,
    },
  ] = useLazyGetConnectorDetailsQuery();

  const [
    getExternalConnector,
    {
      data: externalConnectorData,
      isLoading: externalConnectorIsLoading,
      isError: externalConnectorIsError,
      error: externalConnectorError,
      isSuccess: externalConnectorIsSuccess,
    },
  ] = useLazyGetExternalConnectorQuery();

  return {
    createConnector,
    createConnectorData,
    createConnectorIsLoading,
    createConnectorIsError,
    createConnectorError,
    createConnectorIsSuccess,
    getAllConnectorsData,
    getAllConnectorsIsLoading,
    getAllConnectorsIsError,
    getAllConnectorsError,
    getAllConnectorsIsSuccess,
    refetchGetAllConnectors,
    getConnectorDetails,
    connectorData,
    connectorIsLoading,
    connectorIsError,
    connectorError,
    connectorIsSuccess,
    getExternalConnector,
    externalConnectorData,
    externalConnectorIsLoading,
    externalConnectorIsError,
    externalConnectorError,
    externalConnectorIsSuccess,
  };
};
